import React from "react";
import { Field, ErrorMessage } from "formik";
import styles from "./Input.module.scss";
import ErrorText from "components/shared/errortext/ErrorText";
// import TextError from '../shared/TextError'
// import { TextField } from '@mui/material'

const Input = (props) => {
  const { label, name, icon, placeholder, isRequired, type, ...rest } = props;

  return (
    <div className={styles.inputControl}>
      <label className={styles.label} htmlFor={name}>
        {label}{" "}
        {isRequired ? <span className={styles.requiredMark}>*</span> : ""}
      </label>
      <Field name={name}>
        {({ field }) => {
          return (
            <input
              {...field}
              {...rest}
              id={name}
              min={type === "number" ? 1 : undefined}
              type={type || "text"}
              className={`${styles.inputField} ${rest.className}`}
              placeholder={placeholder}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default Input;
